export default __webpack_public_path__ + "static/media/A6.33a57969.mp3";